export enum BillTabTypeEnum {
  ConsumerOverview = "consumer",
  Billing = "bill",
  BillingDetails = "billingdetails",
}

export enum BillDetailsTabsKey {
  VolumeDetail = "VolumeDetail",
  PictureMember = "PictureMember",
  Machine = "Machine",
  DesktopVolumeDetail = "DesktopVolumeDetail",
}
